export default __webpack_public_path__ + "static/media/A30.67d6fb2e.png";